import store from '../store';
import axios from 'axios';
import RequestService from './request-service';

/**
 * Class for loading default layout from admin
 */
export default class AllLayoutsRequestService extends RequestService {
  /**
   * Class constructor method
   */
  constructor() {
    super();
    /**
     * Endpoint url
     * @type {string}
     */
    this.endpoint = this.$config.endpoints.allLayouts;
    /**
     * Method type
     * @type {string}
     */
    this.method = 'get';
    this.headers = null;
  }

  /**
   * Get base layouts
   */
  getLayouts() {
    // This call will be made from external system for external clients only
    if (typeof APP_SETTINGS.layoutsApiUrl !== 'undefined') {
      axios.get(APP_SETTINGS.layoutsApiUrl)
        .then((resp) => {
          store.commit('setLayouts', resp.data);
        })
        .catch((err) => {
          // eslint-disable-next-line
          console.log(err);
        });
    } else {
      // for clients with BtoBet portal will execute this request
      this.execute((resp) => {
        store.commit('setLayouts', resp.data);
      }, () => {

      });
    }
  }
}
